import React, {Component} from 'react';
import { Container,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import news_banner from '../img/news_banner.jpg'
import syrq from '../img/syrq.png'
import fwms from '../img/fwms.png'
import hjqxyl from '../img/hjqxyl.png'
import npnj from '../img/npnj.png'
import rfjk from '../img/rfjk.png'
import nbpl from '../img/nbpl.png'
import fyyf from '../img/fyyf.png'
import dhjfxf from '../img/dhjfxf.png'
import pfjs from '../img/pfjs.png'
import hxjfgz from '../img/hxjfgz.png'
import xyxh from '../img/xyxh.png'
import shwstt from '../img/shwstt.png'
import bhst from '../img/bhst.png'
import shjrst from '../img/shjrst.png'
import jhmyxt from '../img/jhmyxt.png'
import jkglfw from '../img/jkglfw.png'
import weektc from '../img/weektc.png'
import mouthtc from '../img/mouthtc.png'
import bntc from '../img/bntc.png'
import yeartc from '../img/yeartc.png'
import gmlc from '../img/gmlc.png'
import zysx from '../img/zysx.png'
import './all.css'


class News extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    handleEnter = el=>{
        $('.'+el).css({'display':'block'})
    }
    handleOut = el=>{
        $('.'+el).css({'display':'none'})
    }
    render() {
        return (
            <div>
                <Row className='margin0'>
                    <Col xs={12}>
                        <img className="d-block w-100" src={news_banner} />
                    </Col>
                </Row>
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'3%'}}>润方调理服务</h4>
                        <div style={{margin:'2% 0'}}>Meridians assessment service</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover1')} onMouseLeave={()=>this.handleOut('hover1')}>
                            <img src={hjqxyl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>解情绪压力</div>
                            <div className='rftl_item_msg'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                            <div className='rftl_item_hover display_none hover1'>
                                <div className='rftl_item_hover_msg center'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                                <div className='rftl_item_title_hover center'>解情绪压力</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover2')} onMouseLeave={()=>this.handleOut('hover2')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解尿频尿急</div>
                            <div className='rftl_item_msg'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                            <div className='rftl_item_hover display_none hover2'>
                                <div className='rftl_item_hover_msg center'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                                <div className='rftl_item_title_hover center'>缓解尿频尿急</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover3')} onMouseLeave={()=>this.handleOut('hover3')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解术后疼痛</div>
                            <div className='rftl_item_msg'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                            <div className='rftl_item_hover display_none hover3'>
                                <div className='rftl_item_hover_msg center'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                                <div className='rftl_item_title_hover center'>缓解术后疼痛</div>
                            </div>
                        </div>
                    </Col>
                   
                </Row>
                <Row className="justify-content-md-center">
                <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover4')} onMouseLeave={()=>this.handleOut('hover4')}>
                            <img src={rfjk} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>呵护乳房健康</div>
                            <div className='rftl_item_msg'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                            <div className='rftl_item_hover display_none hover4'>
                                <div className='rftl_item_hover_msg center'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                                <div className='rftl_item_title_hover center'>呵护乳房健康</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover5')} onMouseLeave={()=>this.handleOut('hover5')}>
                            <img src={nbpl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解脑部疲劳</div>
                            <div className='rftl_item_msg'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                            <div className='rftl_item_hover display_none hover5'>
                                <div className='rftl_item_hover_msg center'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                                <div className='rftl_item_title_hover center'>缓解脑部疲劳</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover6')} onMouseLeave={()=>this.handleOut('hover6')}>
                            <img src={fyyf} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>新冠肺炎预防</div>
                            <div className='rftl_item_msg'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                            <div className='rftl_item_hover display_none hover6'>
                                <div className='rftl_item_hover_msg center'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                                <div className='rftl_item_title_hover center'>新冠肺炎预防</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default News;

